module.exports = __webpack_public_path__ + "media/images/front/about/bg_point2-23ab9a7c95a376c9be95f9710df671e5.jpg";